import { removePropertyEmpty } from '@/utils/index'
import { Service } from '../config'

class ManagementAnalysisService extends Service {
  path = 'analisegerencial'

  async get(params?: any) {
    const httpResponse = await this.httpClient.get(this.path, {
      params: removePropertyEmpty(params)
    })

    return httpResponse
  }
}

export const managementAnalysisService = new ManagementAnalysisService()
